module.exports = "/assets/data/86447063c0ccce7449d7a4dd1a188305-E14.data.json";